module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('feedback-modal', {
    ref: "feedbackModal",
    staticClass: "action-modal"
  }, [_c('div', {
    staticClass: "action-modal__message"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-center action-modal__button"
  }, [_c('action-button', {
    attrs: {
      "label": _vm.buttonText,
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241ef0e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/modal/ActionModal.vue
// module id = 1839
// module chunks = 0